import React, { FC } from 'react';
import { Spinner, SpinnerExtendedProps } from 'grommet';
import { StyledSpinnerContainer } from './Styles';

export const LoadingSpinner: FC<SpinnerExtendedProps> = ({ size }) => (
  <StyledSpinnerContainer>
    <Spinner size={size || 'medium'} />
  </StyledSpinnerContainer>
);
